<template>
  <section class="page">
    <div class="page-header">
      <div class="page-header-start">
        <h3 class="page-title">Pin Job</h3>
        <button class="button primary" @click="openJobDetail()">
          <i class="fas fa-bullhorn"></i>Post Job
        </button>
      </div>

      <div class="page-header-end">
        <p class="datepicker">
          <span class="label">Start Date</span>
          <span
            ><input
              class="input"
              v-model="date1"
              type="date"
              placeholder="select start date"
          /></span>
        </p>
        <p class="datepicker">
          <span class="label">End Date</span>
          <span
            ><input
              class="input"
              v-model="date2"
              type="date"
              placeholder="select end date"
          /></span>
        </p>

        <div class="button-group">
          <button
            @click="downloadTemplate()"
            :class="['button sm primary', { 'is-loading': isLoading }]"
          >
            <i class="fad fa-file-excel"></i>Export
          </button>
        </div>
      </div>
    </div>

    <div class="tabs-container">
      <div class="tabs">
        <div class="tabs-start">
          <router-link
            :to="{
              query: {
                type: 'online',
                q: $route.query.q,
                p: $route.query.p,
                s: $route.query.s,
              },
            }"
            class="tab"
            >Online</router-link
          >
          <router-link
            :to="{
              query: {
                type: 'schedule',
                q: $route.query.q,
                p: $route.query.p,
                s: $route.query.s,
              },
            }"
            class="tab"
            >Scheduled</router-link
          >
          <router-link
            :to="{
              query: {
                type: 'expired',
                q: $route.query.q,
                p: $route.query.p,
                s: $route.query.s,
              },
            }"
            class="tab"
            >Expired</router-link
          >
        </div>

        <div class="tabs-end">
          <div class="search control">
            <input
              type="text"
              v-model="search"
              class="input"
              placeholder="Company name"
              v-on:keyup="isSeach()"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div class="box">
        <transition name="slide">
          <pinJobDeatil v-if="viewJobDetail" @cancel="viewJobDetail = false" />
        </transition>
        <pinjobList v-if="!viewJobDetail" />
      </div>
    </div>
  </section>
</template>

<script>
import pinjobList from "./pinjob-list.vue";
import pinJobDeatil from "./pinjob-detail.vue";
import axios from "axios";
import moment from "moment";
export default {
  components: { pinjobList, pinJobDeatil },
  data: () => ({
    viewJobDetail: false,
    search: "",
    date1: "",
    date2: "",
    isLoading: false,
  }),
  methods: {
    openJobDetail() {
      this.viewJobDetail = !this.viewJobDetail;
    },
    isSeach() {
      this.$router
        .push({
          name: "pin-job",
          query: {
            type: this.$route.query.type,
            p: 10,
            q: 1,
            s: this.search,
          },
        })
        .catch(() => {});
    },
    async downloadTemplate() {
      try {
        const date1 = moment(this.date1).format("YYYY-MM-DD");
        const date2 = moment(this.date2).format("YYYY-MM-DD");
        this.isLoading = true;
        await this.$store.dispatch("loading");
        axios.defaults.headers["Authorization"] = this.$store.getters.Token;
        const res = await axios.get(
          `${process.env.VUE_APP_HTTPS_ADMIN}/api/export-pinjobs?date1=${date1}&date2=${date2}`,
          {
            responseType: "blob",
          }
        );
        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Pin Job.xlsx");
        document.body.appendChild(link);
        link.click();
        this.isLoading = false;
        await this.$store.dispatch("completed");
      } catch (err) {
        await this.$store.dispatch("error");
        throw new Error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header-end {
  margin-left: auto;
  display: flex;
  align-items: center;

  ul {
    list-style-type: none;
    margin: 0;
    display: flex;
    align-items: center;

    li {
      display: flex;
      align-items: center;
      margin: 0;
      padding: 0%;
      flex-grow: 1;
      margin-left: 10px;

      span {
        display: block;
        flex-grow: 1;

        &:first-child {
          margin-right: 10px;
        }

        input.input {
          font-size: var(--md-font);
          padding: 0 10px;
          background-color: #fff;
          border: none;
        }
      }
    }
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: all 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-enter {
  opacity: 0;
  transform: translateX(20px);
}

.slide-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
